<small class="debug">{{me}}</small>
@if (cartProduct) {
  <div mat-dialog-content>
    <mat-icon class="moveMatIcon">monetization_on</mat-icon>
    <mat-label>special offer | limited time</mat-label>
    <app-product [cartProduct]="cartProduct" fxLayout="column" id="{{ 'p_' + cartProduct.product_id }}">
    </app-product>
  </div>
}


